// extracted by mini-css-extract-plugin
export default {"statisticContainer":"wuVNkJ3cLswWSn6WBjaZ","columnView":"x8qHN4LVtPFE1UEJRn8H","row":"Mk4ra48a4HSLBlG5MXwu","name":"gvILMyR4C12dtGslCux7"};